<!--
 * @Descripttion: 轮播图属性设置
 * @Author: zenghua.wang
 * @Date: 2021-12-20 10:28:09
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-01-11 11:12:51
-->
<template>
  <el-collapse
    v-model="collapse"
    accordion
  >
    <el-collapse-item
      name="1"
      :title="component.basic"
    >
      <config-base :data="data" />
    </el-collapse-item>

    <!-- 接口设置 -->
    <api-interface
      :data="data"
      :apis="main.apiTableList"
    >
      <template v-slot:extend>
        <config-field
          :data="data"
          :showType="showTypeList"
          :rename="false"
        />
        <config-filter :data="data" />
      </template>
    </api-interface>

    <el-collapse-item title="轮播图设置">
      <!-- <el-form-item label="隐藏">
        <el-switch
          v-model="data.option.hide"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item> -->

      <el-form-item
        label="全屏"
        v-if="category==='report'"
      >
        <el-switch
          v-model="data.option.fullScreen"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item label="自动播放">
        <el-switch
          v-model="data.option.autoplay"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item label="循环播放">
        <el-switch
          v-model="data.option.loop"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item label="轮播时间">
        <el-input-number v-model="data.option.duration" />
      </el-form-item>

      <el-form-item label="显示箭头">
        <el-radio-group
          v-model="data.option.arrow"
          size="mini"
        >
          <el-radio-button label="always">总是</el-radio-button>
          <el-radio-button label="hover">经过</el-radio-button>
          <el-radio-button label="never">从不</el-radio-button>
        </el-radio-group>
        <div class="xa-form-tips">注意：移动端不显示箭头</div>
      </el-form-item>

    </el-collapse-item>

    <!-- 标题设置 -->
    <el-collapse-item title="标题设置">
      <el-form-item label="显示">
        <el-switch
          v-model="data.option.showTitle"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <template v-if="data.option.showTitle">
        <el-form-item label="字体大小">
          <el-input-number v-model="data.option.fontSize" />
        </el-form-item>

        <el-form-item label="字体颜色">
          <el-color-picker
            v-model="data.option.color"
            :predefine="predefineColors"
          ></el-color-picker>
        </el-form-item>

        <el-form-item label="字体粗细">
          <el-select
            v-model="data.option.fontWeight"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in weightList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="对齐方式">
          <el-select
            v-model="data.option.textAlign"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in alignList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </template>
    </el-collapse-item>

    <!-- 权限设置 -->
    <config-auth :data="data" />
  </el-collapse>
</template>

<script>
import {
  predefineColors,
  component,
  theme
} from '@/dragComponents/model/default.js'

import configBase from '@/dragComponents/config/common/base.vue'
import configAuth from '@/dragComponents/config/common/auth.vue'
import apiInterface from '@/dragComponents/config/api/index.vue'
import configField from '@/dragComponents/config/common/field.vue'
import configFilter from '@/dragComponents/config/common/filter.vue'

export default {
  name: 'config-swiper',
  components: {
    configBase,
    configAuth,
    configField,
    configFilter,
    apiInterface
  },
  inject: ['main', 'category'],
  props: ['data', 'collapse'],
  data() {
    return {
      theme: theme,
      predefineColors: predefineColors,
      component: component,
      weightList: component.weightType,
      alignList: component.alignType,
      showTypeList: [
        {
          label: '图片',
          value: 'value'
        },
        {
          label: '标题',
          value: 'name'
        }
      ]
    }
  }
}
</script>
